<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <el-form-item label="类别">
                <el-select v-model="formInline.proType" clearable filterable  placeholder="类别" @change="handlePlatformChange">
                    <el-option v-for="item in itemTypeData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称">
                <el-select v-model="formInline.proId" clearable filterable placeholder="名称">
                    <el-option v-for="item in items"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getReserves">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="reserveList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRO_ID" label="ID" width="170"></el-table-column>
            <el-table-column prop="PRO_NAME" label="名称">
                <template slot-scope="scope">
                    <el-link :href="getLink(scope.row)" target="_blank">
                        <el-button type="success" size="mini" class="header-btn">{{scope.row.PRO_NAME}}-{{scope.row.AUTO_SEND==1?'自动推送':'手动推送'}}</el-button>
                    </el-link>
                    <el-tooltip class="item" effect="dark" content="点击跳转页面查看详情" placement="top-start">
                        <p class="el-icon-question"></p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="PRO_TYPE" label="类型" width="150"></el-table-column>

          <el-table-column label="对应动作" width="150">
              <template slot-scope="scope">
                <el-label >{{scope.row.PRO_TYPE=='促销'||scope.row.PRO_TYPE=='单品'?'预约到货通知':'预约提醒模板'}}</el-label>
              </template>
          </el-table-column>
          <el-table-column label="对应模板" width="180">
              <template slot-scope="scope">
                <el-label >{{scope.row.PRO_TYPE=='促销'||scope.row.PRO_TYPE=='单品'?'小程序:预约到货通知':'小程序:订阅活动开始提醒；公众号：产品预约结果通知'}}</el-label>
              </template>
          </el-table-column>
          <el-table-column prop="ALL_SUM" label="预约数" width="100"></el-table-column>
            <el-table-column prop="HAS_SEND" label="已发送数" width="100"></el-table-column>
            <el-table-column prop="NOT_SEND" label="未发送数" width="100"></el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="点击发给自己看看消息什么样子" placement="top-end">
                        <el-button type="primary" size="mini"  @click="handleSendPreviewMsg(scope.row)">预览消息</el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="发送提醒模板消息" placement="top-end">
                        <el-button type="success" size="mini" @click="handleSendMsg(scope.row)">发送模板消息</el-button>
                    </el-tooltip>
                    <el-button type="primary"  size="mini" @click="exportUser(scope.row)">导出用户</el-button>
                    <el-tooltip class="item" effect="dark" content="点击可发送活动上挂载的优惠券" placement="top-end">
                        <el-button type="warning" size="mini" v-show="scope.row.PRO_TYPE=='活动'" @click="handleSendCashticket(scope.row)">发送优惠券</el-button>
                    </el-tooltip>
                    <!--<el-button type="primary" size="mini" v-show="scope.row.PRO_TYPE2=='1'||scope.row.PRO_TYPE2=='2'||scope.row.PRO_TYPE2=='4'||scope.row.PRO_TYPE2=='6'" @click="openSendCashticket(scope.row)">发送优惠券</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" >
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="选择活动发放优惠券" :visible.sync="showDialog">
            <el-form :model="activeForm" class="demo-ruleForm">
                <el-form-item label="请选择活动">
                    <el-select v-model="activeForm.activeNo"
                               filterable
                               clearable
                               remote
                               :remote-method="initActiveList"
                               @change="activeChange"
                               placeholder="输入活动名称查询">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="sendCoupon">发送优惠券</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="输入绑定微信商城手机号/openId" :visible.sync="showPreviewDialog">
            <el-form :model="activeForm" class="demo-ruleForm" :required="true">
                <el-form-item label="输入绑定微信商城手机号/openId">
                    <el-input v-model="preViewMobile" class="is-required" placeholder="输入绑定微信商城手机号或openId" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="sendPreviewMessage()">发送预览</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {getReserveList, sendReserveMessage,sendReserveCoupon,getConfigSalesTypeList,getItems,exportCustomerList,sendReserveCoupon2,getActiveList,sendPreview} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    proType:'5',
                    proId:'',
                    recordsTotal: 0
                },
                showDialog: false,
                showPreviewDialog:false,
                loading: true,
                itemTypeData:[],
                items:[],
                preViewMobile:'',
                activeList:[],
                activeForm:{
                    activeNo: "",
                    activeName: "",
                    activeType:'',
                    currentPage: 1,
                    pageSize: 20,
                    status:''
                },
                reserve: {
                    PRO_ID: '',
                    PRO_NAME: '',
                    PRO_TYPE: '',
                    PRO_TYPE2: '',
                    HAS_SEND: 0,
                    NOT_SEND: 0,
                },
                templemodle:'预约提醒模板',
                reserveList: []// 活动列表
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.handlePlatformChange(this.formInline.proType);
            this.getReserves();
            getConfigSalesTypeList().then((res) => {
                this.itemTypeData = res.data.value
            });
        },
        methods: {
            getReserves(){
                this.loading = true;
                getReserveList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.reserveList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSendMsg(row){
                if(confirm("确定发送【" + row.PRO_NAME + "】的预约提醒吗？")){
                    sendReserveMessage({"bindCode" : row.PRO_ID,"type":row.PRO_TYPE2}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getReserves();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            handleSendPreviewMsg(data){
                this.showPreviewDialog=true;
                this.reserve= {
                    PRO_ID: data.PRO_ID,
                    PRO_NAME: data.PRO_NAME,
                    PRO_TYPE: data.PRO_TYPE,
                    PRO_TYPE2:data. PRO_TYPE2,
                    HAS_SEND:data. HAS_SEND,
                    NOT_SEND: data.NOT_SEND,
                }
            },
            sendPreviewMessage(){
                if(this.preViewMobile==''){
                    this.$message({
                        showClose: true,
                        message: '手机号必须输入',
                        type: 'error'
                    });
                    return;
                }
                let actionId=this.reserve.PRO_TYPE2=='1'?'reserveArrived':'';
                sendPreview({"openId" : this.preViewMobile,"actionId":actionId}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showPreviewDialog=false;
                });
            },
            handleSendCashticket(row){
                //预约活动发放优惠券
                if(confirm(" 确定发送给预约【" + row.PRO_NAME + "】的用户发送优惠券吗？")){
                    sendReserveCoupon({"bindCode" : row.PRO_ID}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '正在发放优惠券，请在优惠券领取列表中查看',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            openSendCashticket(data){
                this.showDialog=true;
                this.reserve= {
                    PRO_ID: data.PRO_ID,
                    PRO_NAME: data.PRO_NAME,
                    PRO_TYPE: data.PRO_TYPE,
                    PRO_TYPE2:data. PRO_TYPE2,
                    HAS_SEND:data. HAS_SEND,
                    NOT_SEND: data.NOT_SEND,
                }
            },
            sendCoupon(){
                //非预约活动(预约商品、促销、套装发放优惠券)
                if(confirm("确定发送给预约【" + this.reserve.PRO_NAME + "】的用户发送优惠券吗？")){
                    sendReserveCoupon2({"bindCode" : this.activeForm.activeNo,"proId":this.reserve.PRO_ID,"type":this.reserve.PRO_TYPE2}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '正在发放优惠券，请在优惠券领取列表中查看',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            exportUser(data){
                console.log(`${exportCustomerList}?proId=${data.PRO_ID}&type=${data.PRO_TYPE2}&status=0&pageRouterUrl=1`)
                window.open(`${exportCustomerList}?proId=${data.PRO_ID}&type=${data.PRO_TYPE2}&status=0&pageRouterUrl=1`)
            },
            getLink(data){
                let returnUrl = ''
                if(this.formInline.proType=='5'){
                    returnUrl = `${window.location.origin}/#/activeManagement?bindCode=${data.PRO_ID}`
                }else if(this.formInline.proType=='1'){
                    returnUrl = `${window.location.origin}/#/promotionlist?promotionId=${data.PRO_ID}`
                }else if(this.formInline.proType=='4'||this.formInline.proType=='6'){
                    returnUrl = `${window.location.origin}/#/productlist?proName=${data.PRO_NAME}`
                }else if(this.formInline.proType=='2'){
                    returnUrl = `${window.location.origin}/#/grouplist?groupName=${data.PRO_NAME}`
                }
                return returnUrl
            },
            initActiveList(activeName){
                this.activeForm.activeName=activeName;
                this.activeList=[];
                getActiveList(this.activeForm).then((res) => {
                    console.log(res.data.value.list)
                    this.activeList = res.data.value.list;
                })
            },
            activeChange(item){
                this.activeForm.activeNo=item;
            },
            handlePlatformChange(data){
                //商品
                getItems({itemType:data}).then((res) => {
                    console.log(res);
                    this.items = res.data;
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getReserves();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getReserves();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/activeReserve.vue